import * as api from "@/api/williams/welders";
import { getCompaniesFromQualifier } from "@/api/company";
import { queryKeys } from "../../queryKeys";
import { useQuery, useQueryClient } from "react-query";

export function useWelderProfile(welderId?: string) {
  const queryClient = useQueryClient();
  const id = welderId ?? "";

  return useQuery({
    enabled: Boolean(id),
    queryKey: queryKeys.welder.single(id),
    queryFn: async () => {
      const data = await api.getWelderById(id);
      await queryClient.prefetchQuery(["companies", "qualifier"], getCompaniesFromQualifier);
      return data;
    },
  });
}
